import Field from 'Component/Field';
import { FIELD_RADIO_NONE, FIELD_TYPE } from 'Component/Field/Field.config';
import ProductWishlistButton from 'Component/ProductWishlistButton';
import YBRecomendadorTalla from 'Component/YBRecomendadorTalla';
import {
    ProductBundleOption as SourceProductBundleOption
} from 'SourceComponent/ProductBundleOption/ProductBundleOption.component';
import { formatPrice } from 'Util/Price';
import {
    getProductInStock
} from 'Util/Product/Extract';
import { getEncodedBundleUid } from 'Util/Product/Transform';

import './ProductBundleOption.override.style';

/** @namespace Elganso/Component/ProductBundleOption/Component */
export class ProductBundleOptionComponent extends SourceProductBundleOption {
    renderRadio(name, option) {
        const {
            uid,
            can_change_quantity: canChangeQuantity,
            quantity: defaultQuantity = 1,
            product,
            attribute_options
        } = option;
        const {
            getIsChecked,
            quantity: { [uid]: quantity = defaultQuantity },
            options
        } = this.props;
        let label = 'x';
        if (attribute_options) {
            label = attribute_options[0].size;
        }
        const isNone = !attribute_options;

        const stock = (product && uid !== FIELD_RADIO_NONE) ? getProductInStock(product) : 'true';

        let optionSku = null;

        if (options[1].attribute_options) {
            optionSku = options[1].product.sku.split('-')[0];
        }

        return (
            <div block="ProductBundleItem" elem="Radio" mods={ { customQuantity: canChangeQuantity, isNone } } key={ uid } data-product-sku={ optionSku }>
                <Field
                  type={ FIELD_TYPE.radio }
                  label={ label }
                  attr={ {
                      id: `option-${ uid }`,
                      value: canChangeQuantity ? getEncodedBundleUid(uid, quantity) : uid,
                      name: `option-${ name }`,
                      checked: getIsChecked(canChangeQuantity, uid, quantity)
                  } }
                  events={ {
                      onChange: this.updateSelect.bind(this)
                  } }
                  validationRule={ {
                      match: this.getError.bind(this, quantity, stock)
                  } }
                  validateOn={ ['onChange'] }
                  isDisabled={ !stock }
                />
                { canChangeQuantity && this.renderQuantityChange(uid, quantity, product) }
            </div>
        );
    }

    renderWishlistButton() {
        const { options } = this.props;
        const magentoProduct = [
            {
                sku: options[1].product.sku.split('-')[0],
                quantity: 1,
                selected_options: [],
                entered_options: []
            }
        ];

        return (
            <ProductWishlistButton
              magentoProduct={ magentoProduct }
              mix={ {
                  block: 'ProductBundleItem',
                  elem: 'WishListButton'
              } }
            />
        );
    }

    renderYBRecomendadorTallas() {
        const { options, product, title } = this.props;

        let imgUrl = null;
        let optionSku = null;

        if (options[1].attribute_options) {
            imgUrl = options[1].attribute_options[0].smallImage;
            optionSku = options[1].product.sku.split('-')[0];
        }

        if (product !== null) {
            return (
                <YBRecomendadorTalla
                  product={ product }
                  bundleImg={ imgUrl }
                  bundleSku={ optionSku }
                  bundleName={ title }
                  bundleOptions={ options }
                />
            );
        }

        return null;
    }

    render() {
        const {
            title, options, type, currencyCode
        } = this.props;
        const render = this.renderMap[type];

        if (!render) {
            return null;
        }
        let imgUrl = '';
        let optionPrice = null;
        let optionSku = null;
        let optionColor = null;
        if (options[1].attribute_options) {
            imgUrl = options[1].attribute_options[0].smallImage;
            optionPrice = formatPrice(options[1].finalOptionPrice, currencyCode);
            optionSku = options[1].product.sku.split('-')[0];
            optionColor = options[1].attribute_options[0].colorSwatch;
        }

        return (
            <div block="ProductBundleItem" elem="Wrapper">
                <div block="ProductBundleItem" elem="WrapperLeft">
                    { title && this.renderOptionGroupTitle(title) }
                    <div block="ProductBundleItem" elem="Sku">
                        { optionSku }
                    </div>
                    <div block="ProductBundleItem" elem="Recommendador">
                        { this.renderYBRecomendadorTallas() }
                    </div>
                    <div block="ProductBundleItem" elem="Price">
                        <div block="ProductBundleItem" elem="PriceWishlist">
                            { this.renderWishlistButton() }
                        </div>
                        <div block="ProductBundleItem" elem="PriceFinal">
                            { optionPrice }
                        </div>
                    </div>
                    <div block="ProductBundleItem" elem="Separator">
                        <hr block="ProductBundleItemSeparator" />
                    </div>
                    <div block="ProductBundleItem" elem="Color">
                        <div block="ProductBundleItem" elem="SwachColor" style={ { backgroundColor: optionColor } } />
                    </div>
                    <div block="ProductBundleItem" elem="Options">
                        { options && render(options) }
                    </div>
                </div>
                <div block="ProductBundleItem" elem="WrapperRight">
                    <img
                      alt={ title }
                      src={ imgUrl }
                    />
                </div>
            </div>
        );
    }
}

export default ProductBundleOptionComponent;
